exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buy-domain[data-v-b5c9f6f0]{width:140px;height:40px;max-width:140px;background:#fff;border-radius:4px}.buy-domain .first__step[data-v-b5c9f6f0]{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.buy-domain .first__step .btn__buy__domain[data-v-b5c9f6f0]{border-radius:6px;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:#42c31b;color:#fff;font-size:13px;font-weight:900;text-align:center;padding:4px;font-family:Muli;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b5c9f6f0","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/dashboard-v5/buy-domain/BuyDomain.vue
// module id = YH0F
// module chunks = 0